import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery, REFETCH_POLICY} from 'src/axiosBaseQuery';
import {getReportServiceURL} from 'src/utils/helper';
import {
    BusinessStatistic,
    ChargerStatistic,
    CityStatistic,
    CompanyStatistic,
    ConsumptionChartRequest,
    ConsumptionChartResponse,
    ConsumptionRequest,
    ConsumptionTotals,
    GroupedConsumptionResponse,
    LocationStatistic,
    RealEstateStatistic,
    UserStatistic,
} from 'src/types';

export const reportServiceApi = createApi({
    reducerPath: 'reportServiceApi',
    ...REFETCH_POLICY,
    baseQuery: axiosBaseQuery({
        baseUrl: String(getReportServiceURL() + '/reports'),
    }),
    endpoints: (build) => ({
        getConsumption: build.query<ConsumptionTotals, ConsumptionRequest>({
            query: (data) => ({url: '/consumption', method: 'post', data}),
        }),
        getConsumptionByLocations: build.query<
            GroupedConsumptionResponse<LocationStatistic>,
            ConsumptionRequest
        >({
            query: (data) => ({url: '/consumption/locations', method: 'post', data}),
        }),
        getConsumptionByCities: build.query<
            GroupedConsumptionResponse<CityStatistic>,
            ConsumptionRequest
        >({
            query: (data) => ({url: '/consumption/cities', method: 'post', data}),
        }),
        getConsumptionByUsers: build.query<
            GroupedConsumptionResponse<UserStatistic>,
            ConsumptionRequest
        >({
            query: (data) => ({url: '/consumption/users', method: 'post', data}),
        }),
        getConsumptionByChargers: build.query<
            GroupedConsumptionResponse<ChargerStatistic>,
            ConsumptionRequest
        >({
            query: (data) => ({url: '/consumption/chargers', method: 'post', data}),
        }),
        getConsumptionByBusinesses: build.query<
            GroupedConsumptionResponse<BusinessStatistic>,
            ConsumptionRequest
        >({
            query: (data) => ({url: '/consumption/businesses', method: 'post', data}),
        }),
        getConsumptionByCompanies: build.query<
            GroupedConsumptionResponse<CompanyStatistic>,
            ConsumptionRequest
        >({
            query: (data) => ({url: '/consumption/companies', method: 'post', data}),
        }),
        getConsumptionByRealEstates: build.query<
            GroupedConsumptionResponse<RealEstateStatistic>,
            ConsumptionRequest
        >({
            query: (data) => ({url: '/consumption/real-estates', method: 'post', data}),
        }),
        getConsumptionChart: build.query<ConsumptionChartResponse, ConsumptionChartRequest>({
            query: (data) => ({url: '/consumption/chart', method: 'post', data}),
        }),
    }),
});
